import type { ReactElement } from 'react';
import * as RR from 'react-router';

import emptyRecord from '@studio/utils/emptyRecord';
import { isObjectWithExperience } from '@studio/utils/experience';
import shallowEqual from '@studio/utils/shallowEqual';

function getExperience(state: unknown): object {
  return isObjectWithExperience(state) ? state.experience : emptyRecord;
}

export type { PromptProps } from 'react-router';

export default function Prompt({
  when = true,
  message,
}: RR.PromptProps): ReactElement {
  const prevLocation = RR.useLocation();

  return (
    <RR.Prompt
      when={when}
      message={(nextLocation, action) => {
        // Allow navigation if:
        if (
          // 1. The path names are equal
          prevLocation.pathname === nextLocation.pathname &&
          // 2. The experience objects are equal
          shallowEqual(
            getExperience(prevLocation.state),
            getExperience(nextLocation.state),
          )
        ) {
          return true;
        }

        // Otherwise, fall back to the provided message
        if (typeof message === 'function') {
          return message(nextLocation, action);
        }

        return message;
      }}
    />
  );
}
